<div id="{{popupHeader==='Welcome to the NEW Provider Portal!'?'headerPop':''}}">
  <form #popup="ngForm">
    <div class="backdrop" (click)="this.close()"></div>
    <div class="container pos-bottom" [ngClass]="{
        'no-img': !isImg,
        'info-popup': noOfButtons=='1',
        'popup-container': popupHeader==='Welcome to the NEW Provider Portal!'
      }">
      <div class="popup-header" id="{{popupHeader==='Welcome to the NEW Provider Portal!'?'headerPopContent':''}}">
        {{popupHeader}}
        <img src="../../../../assets/images/close-icon.png" class="close-icon" (click)="this.close()">
      </div>
      <div [ngClass]="{
            'info-box': noOfButtons=='1',
            'warning-msg-box': popupHeader==='Welcome to the NEW Provider Portal!',
            'warning-box': popupHeader!=='Welcome to the NEW Provider Portal!'
          }">
        <img src="../../../../assets/images/warning-icon.png" class="warning-icon" *ngIf="isImg">
        <img src="../../../../assets/images/Delete.png" class="warning-icon mobile-img" *ngIf="isImgDel">
        <div [ngClass]="{
                'w-100': !isImg,
                'mx-auto': !isImg,
                'info-text': noOfButtons=='1'
              }" class="warning-text" [innerHTML]="popupText">
          <!-- {{popupText}} -->
        </div>
      </div>
      <div *ngIf="popupHeader==='Welcome to the NEW Provider Portal!'">
        <div class="popup-content">
          For previous Provider Portal users, please contact us to activate your account:
        </div>
        <div class="popupTextContainer">
          <ul class="popupListContainer">
            <li>Call Benlysta Gateway at 1-877-423-6597 to determine eligibility to activate your existing account</li>
            <li>Validate your account information</li>
            <li>An email will be sent to the registered email address on file with a link to create a new password.</li>
          </ul>
        </div>
      </div>
      <div *ngIf="popupHeader==='Commercial Copay Program authorization'">
        <p class="commercialText">If yes, IZERVAY My Way will determine your eligibility and initiate your enrollment. Please see complete terms and 
          conditions available at <a style="color: #654395; text-decoration: underline;" href="https://www.IZERVAYecp.com/CommercialCopayTermsAndConditions" target="_blank">IZERVAYecp.com/CommercialCopayTermsAndConditions</a>.</p>

      </div>
      <div *ngIf="popupHeader==='BENLYSTA Cares Support'">

        <div class="psp-alignment info-text">
          <div>
            <label class="link--color mb-0">My indication(select all that apply)<span>*</span></label>
            <div class="d-flex justify-content-start align-items-center">
              <input class="check-ht" type="checkbox" name="lupus" id="lupus" [(ngModel)]="lupus" />
              <label class="checkbox-style mb-0" for="lupus">Lupus</label>
            </div>
            <div class="d-flex justify-content-start align-items-center">
              <input class="check-ht" type="checkbox" name="nephritis" id="nephritis" [(ngModel)]="nephritis" />
              <label class="checkbox-style mb-0" for="nephritis">Lupus nephritis</label>
            </div>
          </div>

          <p class="mt-4"> For additional information about how GSK handles your information, please see our privacy
            notice at <span class="link--color"> https://privacy.gsk.com/en-us. </span></p>

          <div class="d-flex mb-3 align-items-center">
            <label>Email address<span>*</span></label>
            <input type="email" class="form-control text-box text" id="consentEmail" name="consentEmail"
              [(ngModel)]="consentEmail" email="true" placeholder="Enter Email address"
              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$" required
              [disabled]="!!patientEmail && patientEmail.length != 0" />
          </div>
          <p>You are encouraged to report negative side effects of prescription drugs to the FDA. Visit
            www.fda.gov/medwatch or call <span class="link--color"> 1-800-FDA-1088</span></p>
        </div>
        <!-- <div class="d-flex justify-content-around">
                <label class="label "> Diagnosis ICD-10 Code</label>

                <div class="box-group" >
                  <div >
                    <input class="form-check-input" type="radio" name="C90.00" [(ngModel)]="diagnosisICD"
                     *ngIf="diagnosisICD=='C90.00'"  
                      id="C90.00" value="C90.00" required/>
                    <label class="label" for="C90.00">C90.00-Multiple myeloma not having achieved remission</label>
                  </div>

                  <div >
                    <input class="form-check-input" type="radio" name="C90.02" [(ngModel)]="diagnosisICD"
                    *ngIf="diagnosisICD=='C90.02'"  
                    id="C90.02" value="C90.02" required/>
                    <label class="label" for="MNE">C90.02-Multiple myeloma in relapse</label>
                  </div>

                  <div class="d-flex align-items-center w-100">
                    <input class="form-check-input other-text-position" type="radio" name="otherDiagnosis"
                      *ngIf="diagnosisICD=='otherDiagnosis'"
                      [(ngModel)]="diagnosisICD" id="otherDiagnosis" value="otherDiagnosis" required/>
                    <label class="label mr-3" for="otherDiagnosis">Other</label>

                    <input type="text" class="form-control box-width" id="otherDiagnosisText"
                     *ngIf="diagnosisICD=='otherDiagnosis'" disabled
                      name="otherDiagnosisText" [(ngModel)]="otherDiagnosisText" required />
                  </div>
                </div>
              </div> -->

      </div>
      <div class="popup-button" *ngIf="noOfButtons=='2'&& !isEsignPopup">
        <button class="no-button" (click)="this.close()">No</button>
        <button (click)="this.confirm()" class="yes-button">Yes</button>
      </div>
      <div class="popup-button" *ngIf="noOfButtons=='2' && isEsignPopup">
        <button class="no-button" (click)="this.close()">Cancel</button>
        <button (click)="this.confirm()" class="yes-button">Proceed</button>
      </div>

      <div class="popup-button-ok" *ngIf="noOfButtons=='1' && texttype=='PspEnrollment'">
        <button (click)="this.confirmHandler()">
          Ok
        </button>
      </div>

      <div class="popup-button-ok" *ngIf="noOfButtons=='1' && texttype!='PspEnrollment'">
        <button (click)="this.confirmHandler()">
          Ok
        </button>
      </div>

    </div>
  </form>
</div>